export const getAssetUrl = (asset: any): string => {
  if (!asset) return ''
  if (typeof asset === 'string') return asset
  if (asset.default && typeof asset.default === 'string') return asset.default
  if (asset.src && typeof asset.src === 'string') return asset.src
  return ''
}
